<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-checkbox-group :theme="$otTheme" v-model="checkboxValue" border round>
                <ot-checkbox :theme="$otTheme" value="1">
                    <span>小圆仔</span>
                </ot-checkbox>
                <ot-checkbox :theme="$otTheme" value="2">
                    <span>小土仔</span>
                </ot-checkbox>
                <ot-checkbox :theme="$otTheme" value="3">
                    <span>其它</span>
                </ot-checkbox>
            </ot-checkbox-group>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            checkboxValue: [ '1' ],
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-checkbox-group%20v-model%3D%22checkboxValue%22%20border%20round%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-checkbox%20value%3D%221%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%3E%E5%B0%8F%E5%9C%86%E4%BB%94%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-checkbox%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-checkbox%20value%3D%222%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%3E%E5%B0%8F%E5%9C%9F%E4%BB%94%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-checkbox%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-checkbox%20value%3D%223%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cspan%3E%E5%85%B6%E5%AE%83%3C%2Fspan%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-checkbox%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-checkbox-group%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20checkboxValue%3A%20%5B%20'1'%20%5D%2C%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
};
</script>
